export default {
    endAdornment: {
        top: 'inherit',
    },
};
